import { render, staticRenderFns } from "./replyBackStatus.vue?vue&type=template&id=e10fd64e&scoped=true&"
import script from "./replyBackStatus.vue?vue&type=script&lang=js&"
export * from "./replyBackStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10fd64e",
  null
  
)

export default component.exports